import React from "react";

import "./RoomNavigationCardStyle.css";

import ArrowRight from "@mui/icons-material/ArrowForwardIosOutlined";

const RoomNavigationCard = ({ content, onClickTrigger }) => {
  return (
    <div className="room-quick-navigation-item" onClick={onClickTrigger}>
      <p style={{ fontSize: "small" }}>{content}</p>
      <ArrowRight />
    </div>
  );
};

export default RoomNavigationCard;
